import { __extends } from "tslib";
import { PerspectiveProjection, AssetBase, Transform } from '@awayjs/core';
import { TextureProjectorEvent } from '../events/TextureProjectorEvent';
/**
 * TextureProjector is an object in the scene that can be used to project textures onto geometry. To do so,
 * the object's material must have a ProjectiveTextureMethod method added to it with a TextureProjector object
 * passed in the constructor.
 * This can be used for various effects apart from acting like a normal projector, such as projecting fake shadows
 * unto a surface, the impact of light coming through a stained glass window, ...
 *
 * @see away3d.materials.methods.ProjectiveTextureMethod
 */
var TextureProjector = /** @class */ (function (_super) {
    __extends(TextureProjector, _super);
    /**
     * Creates a new TextureProjector object.
     * @param texture The texture to be projected on the geometry. Since any point that is projected out of the range
     * of the projector's cone is clamped to the texture's edges, the edges should be entirely neutral.
     */
    function TextureProjector(texture, transform) {
        if (transform === void 0) { transform = null; }
        var _this = _super.call(this) || this;
        _this._transform = transform || new Transform();
        _this._projection = new PerspectiveProjection();
        _this._projection.transform = _this._transform;
        _this._texture = texture;
        var width = texture.getImageAt(0).width;
        var height = texture.getImageAt(0).height;
        return _this;
    }
    Object.defineProperty(TextureProjector.prototype, "transform", {
        get: function () {
            return this._transform;
        },
        set: function (value) {
            if (this._transform == value)
                return;
            this._transform = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextureProjector.prototype, "projection", {
        /**
         *
         */
        get: function () {
            return this._projection;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextureProjector.prototype, "assetType", {
        get: function () {
            return TextureProjector.assetType;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextureProjector.prototype, "texture", {
        /**
         * The texture to be projected on the geometry.
         * IMPORTANT: Since any point that is projected out of the range of the projector's cone is clamped to the texture's edges,
         * the edges should be entirely neutral. Depending on the blend mode, the neutral color is:
         * White for MULTIPLY,
         * Black for ADD,
         * Transparent for MIX
         */
        get: function () {
            return this._texture;
        },
        set: function (value) {
            if (value == this._texture)
                return;
            this._texture = value;
            var width = value.getImageAt(0).width;
            var height = value.getImageAt(0).height;
            this.dispatchEvent(new TextureProjectorEvent(TextureProjectorEvent.TEXTURE_CHANGE));
        },
        enumerable: true,
        configurable: true
    });
    TextureProjector.assetType = '[asset TextureProjector]';
    return TextureProjector;
}(AssetBase));
export { TextureProjector };
